/**
 * Marker class that opts a chat surface into the compact-table treatment defined
 * in `ChatMessageTable.module.css`. Global (not a CSS-module hash) so both the
 * assistive ChatMessage (`copilot-chat`) and the immersive ChatMessage
 * (`copilot-immersive-v1`) can apply the same literal string. Pair with a
 * side-effect import of `ChatMessageTable.module.css` so the stylesheet ships.
 */
export const COMPACT_TABLES_CLASS = 'copilot-chat-compact-tables'
